export const viewRoutes = {
  plans: '/operational-plan',
  results: '/update-results',
  review: '/review-plan-and-result',
  approvals: '/plan-approvals',
  overview: '/performance-overview',
  indicators: '/approved-indicators',
  alerts: '/performance-alerts',
};

export const roleViews = {
  unit: ['plans', 'results', 'overview', 'indicators', 'alerts'],
  strategy: ['review', 'overview', 'indicators', 'alerts'],
  leader: ['approvals', 'overview', 'indicators', 'alerts'],
};

export const defaultView = (role) => roleViews[role]?.[0] || 'overview';

export const routeForRole = (role) => viewRoutes[defaultView(role)];

